


























/** @format */
import { getPlate } from '@/api/fixed-car-management';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getParkingTree, getParkingOldTree } from '@/api/login-parking';
import toTree, { ITreeNode, getLastLevelNodes } from '@root/utils/to-tree';

// 判断两个乱序字符串数组项是否相等
function isEqualStringArr(a, b) {
  if (!(_.isArray(a) && _.isArray(b))) {
    return false;
  }
  // 数组长度为0 不能执行reduce，需要额外处理
  if (a.length === 0 || b.length === 0) {
    return JSON.stringify(a) === JSON.stringify(b);
  }
  if (a.length !== b.length) {
    return false;
  }
  return a.reduce((total, curr) => total ^ curr) === b.reduce((total, curr) => total ^ curr);
}

@Component
export default class ParkingLotSearch extends Vue {
  // v-model
  @Prop()
  value!: string[] | string;

  @Prop({
    type: Boolean,
    default: true
  })
  allowClear: boolean;

  // 是否不可编辑
  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  // 是否依赖全局设置的机构或车场
  @Prop({
    type: Boolean,
    default: false
  })
  isLimitSelectByOverall!: boolean;

  // 是否多选
  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean;

  // 多选情况下，最多展示tag树
  @Prop({
    type: Number,
    default: 1
  })
  maxTagCount!: number;

  // 多选情况下，是否默认全选
  @Prop({
    type: Boolean,
    default: false
  })
  isSelectAll!: boolean;

  // 是否默认展开树
  @Prop({
    type: Boolean,
    default: true
  })
  treeDefaultExpandAll!: boolean;

  // 定义选中项回填的方式。TreeSelect.SHOW_ALL: 显示所有选中节点(包括父节点). TreeSelect.SHOW_PARENT: 只显示父节点(当父节点下所有子节点都选中时). 默认只显示子节点.
  @Prop({
    type: String,
    default: 'SHOW_CHILD'
  })
  showCheckedStrategy!: String;

  //是否把每个选项的 label 包装到 value 中，会把 value 类型从 string 变为 {value: string, label: VNode, halfChecked(treeCheckStrictly 时有效): string[] } 的格式
  @Prop({
    type: Boolean,
    default: false
  })
  labelInValue!: Boolean;

  // 是否查询
  @Prop({
    type: Boolean,
    default: false
  })
  isQuery!: boolean;

  // 查询条件 机构id
  @Prop()
  queryByOrg?: string;

  // 是否使用老接口查询
  @Prop({
    type: Boolean,
    default: false
  })
  useOldHttp!: boolean;

  @Prop({
    type: Boolean,
    default: true
  })
  locatePlateHeadWhenChange!: boolean;

  // isQuery查询车场信息相关
  parkingTreeByQuery: ITreeNode[] | null = [];
  queryParkTreeDebounce: () => void = () => {};
  isUpdateInnerValueWithOverall = false; // 是否需要将当前选择值和全局值同步
  // 为解决重置时，搜索值未清空的情况
  searchValue: string = '';

  // 获得当前用户所属的车场信息
  @Getter('organizations/getUserParkingIotTree')
  getUserParkingIotTree!: any[];
  @Getter('organizations/getUserOrgTreeFirstKeys')
  getUserOrgTreeFirstKeys!: any[];
  @Getter('organizations/userParkingIot')
  getUserParkingIotTreeList!: any[];
  // 全局筛选车场信息
  @Getter('organizations/overallSetParkingIotList')
  overallSetParkingIotList!: string[];
  // @Getter('organizations/overallSetSelectTree')
  // overallSetSelectTree!: any[]

  // 是否有清空按钮功能
  get allowClearALL() {
    if (this.isLimitSelectByOverall) {
      // 依赖全局筛选 且 当前值和全局值一致时，清空按钮消失
      const isEqualOverall = isEqualStringArr(this.innerValue, this.overallSetParkingIotList);
      return this.allowClear && !isEqualOverall;
    } else {
      return this.allowClear;
    }
  }

  // 【:treeData】树状选择下拉数据 -------------------------------------------------------------
  get parkingTree() {
    // 1.treeData数据获取
    let parkingTree = [];
    if (this.isQuery) {
      // 1.1请求数据模式，treeData按接口返回
      if (this.queryByOrg) {
        parkingTree = this.parkingTreeByQuery;
      } else {
        // 查询状态按入参更新下拉框，无数据查询条件时置空
        return [];
      }
      // } else if (
      //   this.isLimitSelectByOverall &&
      //   this.overallSetSelectTree &&
      //   Object.keys(this.overallSetSelectTree).length > 0) {
      //   // 1.2全局筛选模式，treeData按全局设置返回
      //   // this.multiple &&
      //   parkingTree = this.overallSetSelectTree;
    } else {
      // 1.3否则按登录本人权限返回
      parkingTree = this.getUserParkingIotTree;
    }
    // 2.treeData多选，单选处理
    if (this.multiple) {
      return parkingTree;
    } else {
      // 单选时控制只能选则车场
      return this.simpleParkingTree(parkingTree);
    }
  }

  // 树状选择默认展开项, 有选中值则默认展开选中值，无则全部展开
  get treeExpandedKeys() {
    if (this.treeDefaultExpandAll === true) return undefined;

    if (this.parkingTree && this.innerValue) {
      return [this.innerValue];
    } else {
      return this.getUserOrgTreeFirstKeys;
    }
  }
  // -----------------------------------------------------------------------

  // 【:value】当前选中值 -------------------------------------------------------------
  get innerValue() {
    let value = this.value;

    this.$nextTick(() => {
      try {
        if (value && value.length === 0) {
          const dom = document.getElementsByClassName('ant-select-search__field')[0] as any;
          dom.value = '';
        }
      } catch (e) {
        console.error(e);
      }
    });
    // 若组件值设置依赖全局配置 && 当前无选中值或者选中值和前全局值一致时 && 多选或者（单选且全局也是单车场），直接设置全局值
    if (
      this.isLimitSelectByOverall &&
      (!(value && value.length > 0) || this.isUpdateInnerValueWithOverall) &&
      (this.multiple || (!this.multiple && this.overallSetParkingIotList.length === 1))
    ) {
      value = this.overallSetParkingIotList;
      this.onChange(value);
      this.isUpdateInnerValueWithOverall = false;
    }
    return value;
  }
  set innerValue(val) {
    this.onChange(val);
  }
  @Watch('parkingTree')
  parkingTreeChange(newVal) {
    if (this.multiple && this.isSelectAll) {
      // 全选处理
      this.innerValue = getLastLevelNodes(newVal).map((item: ITreeNode) => item.id);
    }
  }
  // 监听全局筛选变化，判断是否需要更新选中项
  @Watch('overallSetParkingIotList')
  overallSetParkingIotListChange(newVal, oldVal) {
    this.isUpdateInnerValueWithOverall = isEqualStringArr(this.innerValue, oldVal);
  }

  // -----------------------------------------------------------------------

  mounted() {
    // 设置车场数据请求防抖方法
    this.queryParkTreeDebounce = _.debounce(this.queryParkingTree, 600);
    // 初始化时先判断一次是否需要请求
    this.onChangeQueryByOrg(this.queryByOrg);
    // @ts-ignore
    const $myTree = this.$refs.myTree.$el;
    if ($myTree) {
      $myTree.addEventListener('input', this.customInputHandle);
    }
  }

  beforeDestroy() {
    // @ts-ignore
    const $myTree = this.$refs.myTree.$el;
    $myTree.removeEventListener('input', this.customInputHandle);
  }

  // 查询状态按入参更新下拉框数据
  @Watch('queryByOrg')
  onChangeQueryByOrg(newVal: string) {
    if (this.isQuery && this.queryByOrg) {
      this.queryParkTreeDebounce();
    }
  }

  async onChange(value: any, label?: any, extra?: any) {
    this.searchValue = '';
    this.$emit('input', value);
    if (this.labelInValue || this.showCheckedStrategy === 'SHOW_CHILD') {
      this.$emit('change', value, label, extra);
    } else {
      // 回填数据包括机构和车场，需要分开处理
      const splitList = this.splitOrgAndPark(value, this.getUserParkingIotTreeList);
      this.$emit('change', value, splitList);
    }
    if (this.locatePlateHeadWhenChange) {
      const { data } = await getPlate({ parkId: value });
      let defaultPlate = data.plateHead || '';
      console.log('defaultPlate--:', defaultPlate);
      this.$emit('plateHead', defaultPlate);
    }
  }

  async queryParkingTree() {
    try {
      let interfaceFun = this.useOldHttp ? getParkingOldTree : getParkingTree;
      const { data = [] } = await interfaceFun({
        orgDepId: this.queryByOrg
      });
      let parkingTreeByQuery = toTree(data, {
        idProp: 'id',
        parentProp: 'parentId',
        titleProp: 'name',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      });
      this.parkingTreeByQuery = parkingTreeByQuery;
    } catch (e) {
      console.error('queryParkingTree', e);
    }
  }

  // 控制单选情况下只能选择车场
  simpleParkingTree(data: ITreeNode[]) {
    const dataClone = _.cloneDeep(data);
    dataClone.forEach(item => {
      if (item.children && item.children.length > 0) {
        item.selectable = false;
        item.children = this.simpleParkingTree(item.children);
      }
    });
    return dataClone;
  }

  // 区分车场和机构,data值可以直接传getUserParkingIotTreeList当前用户下所有机构和车场列表，牺牲性能简化操作
  splitOrgAndPark(value: string[] | string | null, data: ITreeNode[]) {
    const orgIdList: string[] = [];
    const parkIdList: string[] = [];
    if (value) {
      let valueArr: string[] = [];
      if (typeof value === 'string') {
        valueArr.push(value);
      } else {
        valueArr = value;
      }
      valueArr.forEach(item => {
        for (let i = 0, len = data.length; i < len; i++) {
          if (item === data[i].id) {
            if (data[i].type === 'org') {
              orgIdList.push(item);
            } else if (data[i].type === 'park') {
              parkIdList.push(item);
            }
          }
        }
      });
    }
    return {
      parkIdList,
      orgIdList
    };
  }

  // 获取车场的所有id
  getAllParkingId() {
    this.$emit(
      'getAllParkingId',
      getLastLevelNodes(this.parkingTree).map((item: ITreeNode) => {
        return item.id;
      })
    );
  }

  /**
   * 自定义控制input事件，处理中文输入法与placeholder的冲突
   */
  customInputHandle(event) {
    // @ts-ignore
    const $myTree = this.$refs.myTree.$el;
    const $placeholder = $myTree.querySelector('.ant-select-search__field__placeholder');
    const $wrap = $myTree.querySelector('.ant-select-search__field__wrap');
    if (event.target.value) {
      $wrap.style.width = event.target.value.length * 18 + 'px';
      $placeholder.style.display = 'none';
    } else {
      $wrap.style.width = '4px';
      if (!this.innerValue) {
        // tree select输入框中没有选中的值
        $placeholder.style.display = 'block';
      }
    }
  }
}
